import * as React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  Divider,
} from "@common-ui/ui";

import { MoreHoriz } from "@mui/icons-material";
import { BreadcrumbsComponent } from "./Breadcrumbs";

export function MenuAppBarWithBreadcrumbs({ items, noMargin }) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        sx={{
          display: "flex",
          justifyContent: "center",
          bgcolor: "background.paper",
          mb: noMargin ? 0 : 2,
        }}
      >
        <Toolbar>
          <BreadcrumbsComponent items={items} />
          {/* <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} /> */}
        </Toolbar>
        {noMargin && <Divider />}
      </AppBar>
    </Box>
  );
}

export function MenuAppBar({ name, action }) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        sx={{
          display: "flex",
          justifyContent: "center",
          bgcolor: "background.paper",
          mb: 2,
        }}
      >
        <Toolbar>
          <Typography
            variant="h3"
            component="h2"
            color="text.primary"
            fontSize="18px"
            fontWeight="700"
            style={{ color: "#333333" }}
          >
            {name}
          </Typography>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} />
          {action ? <div>{action}</div> : ""}
          <Button
            size="small"
            // variant="outlined"
            disabled
            edge="start"
            aria-label="more"
            onClick={() => alert("Coming soon!")}
          >
            <MoreHoriz />
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
